"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const Portal_1 = require("../Portal/Portal");
/**
 * This component is the root for creating modal style interactions with backdrop.
 * Modal and Drawer components inherit this
 */
function ModalContainer({ isOpen, children, onClose, centerChild = false }) {
    const backdropRef = (0, react_1.useRef)(null);
    const [active, setActive] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        // get dom element from backdrop
        const { current } = backdropRef;
        // when transition ends set active state to match open prop
        const transitionEnd = () => setActive(isOpen);
        // when esc key press close modal unless locked
        const keyHandler = (e) => ['Escape'].indexOf(e.key) >= 0 && onClose();
        let timeout;
        // parent is the current target, if click it (the mask) close the modal
        const parentClickHandler = (e) => {
            if (e.target === e.currentTarget) {
                onClose();
            }
        };
        // if the backdrop exists set up listeners
        if (current) {
            current.addEventListener('transitionend', transitionEnd);
            current.addEventListener('click', parentClickHandler);
            window.addEventListener('keyup', keyHandler);
        }
        // if open props is true add inert to #root
        // and set active state to true
        if (isOpen) {
            timeout = window.setTimeout(() => {
                var _a, _b;
                (_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.blur();
                setActive(true);
                (_b = document.querySelector('#root')) === null || _b === void 0 ? void 0 : _b.setAttribute('inert', 'true');
            }, 10);
        }
        // on unmount remove listeners
        return () => {
            var _a;
            if (current) {
                current.removeEventListener('transitionend', transitionEnd);
                current.removeEventListener('click', parentClickHandler);
            }
            (_a = document.querySelector('#root')) === null || _a === void 0 ? void 0 : _a.removeAttribute('inert');
            window.removeEventListener('keyup', keyHandler);
            window.clearTimeout(timeout);
        };
    }, [isOpen, onClose]);
    return isOpen || active ? ((0, jsx_runtime_1.jsx)(Portal_1.Portal, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ ref: backdropRef, className: (0, classnames_1.default)('flex', 'h-full', 'fixed', 'top-0', 'right-0', 'left-0', 'bottom-0', 'bg-black', 'bg-opacity-50', 'justify-end', 'transition-all', 'delay-200', 'z-20', {
                'opacity-0': !isOpen || !active,
                'opacity-100': isOpen && active,
                'duration-300 delay-[0ms]': isOpen && active,
                'items-center justify-center': centerChild
            }) }, { children: children({ active }) })) })) : null;
}
exports.ModalContainer = ModalContainer;
//# sourceMappingURL=ModalContainer.js.map